export const environment = {
  production: true,
  API_ENDPOINT: 'https://landing.dev.optimo.uz/V1/',
  GTAG_ID: '',
  APP_TYPE: 'Landing',
  dashboardLoginPageUrl: 'https://dashboard.dev.optimo.uz/',
};
